import { createContext } from 'react';
export const Context = createContext({
    t: (key) => '',
    tChoice: (key) => '',
    currentLocale: () => '',
    getLocales: () => [''],
    isLocale: (locale) => true,
    loading: true,
    setLocale: (locale) => { }
});
